import moment from "moment";
import { useReducer } from "react";
import OperationStoreCategoriesContext, { internalState } from "./context";
import reducer from "./reducer";
import { execute } from "../../utils/helpers/execute";
import EndPoints from "../../services/end-points";
import { ICreateOperationStoreCategories, IUpdateOperationStoreCategories } from "../../models/operation-store-categories/request";
import { IOperationStoreCategories } from "../../models/operation-store-categories/response";
import { IOperationStoreCategoriesQuery } from "../../models/operation-store-categories/query";

export interface IProps {
  children: React.ReactNode;
}

const OperationStoreCategoriesContextProvider: React.FC<IProps> = (props) => {
  const [state, dispatch] = useReducer(reducer, internalState);
  
  const getData = async () => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });

        const { data } = await EndPoints.operationStoreCategories.getAllOperationStoreCategories(state.query);

        dispatch({ type: "SET_LIST", payload: { list: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });
      },
      throwException: false,
    });
  };

  const getDetails = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });

        const { data } = await EndPoints.operationStoreCategories.getOperationStoreCategories(id);
        dispatch({ type: "SET_DETAILS", payload: { details: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });
      },
      throwException: false,
    });
  };

  const setDetails = async (data?: IOperationStoreCategories) => {
    // dispatch({ type: 'SET_DETAILS', payload: { details: data } })
  };

  const createOperationStoreCategories = async (request: ICreateOperationStoreCategories) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });

        await EndPoints.operationStoreCategories.createOperationStoreCategories(request);
        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: true,
    });
  };

  const updateOperationStoreCategories = async (id: number, request: IUpdateOperationStoreCategories) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
        await EndPoints.operationStoreCategories.updateOperationStoreCategories(id, request);

        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
      },
      throwException: true,
    });
  };

  const deleteOperationStoreCategories = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });

        await EndPoints.operationStoreCategories.deleteOperationStoreCategories(id);

        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });
      },
      throwException: true,
    });
  };

  const setSearch = (search?: string) => {
    dispatch({ type: "SET_SEARCH", payload: { search } });
  };

  const setQuery = (query: IOperationStoreCategoriesQuery) => {
    dispatch({ type: "SET_QUERY", payload: { query } });
  };
  
  const exportExcel = async (request: any) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
        const data = await EndPoints.operationStoreCategories.exportExcel(request, state.query);
        const url = window.URL.createObjectURL(new Blob([data.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `OperationStoreCategories-${moment().format("yyyy-MM-d")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: true,
    });
  };

  return (
    <OperationStoreCategoriesContext.Provider
      value={{
        ...state,
        actions: {
          getData,
          getDetails,
          setDetails,

          createOperationStoreCategories,
          updateOperationStoreCategories,
          deleteOperationStoreCategories,
          exportExcel,

          setSearch,
          setQuery,
        },
      }}
    >
      {props.children}
    </OperationStoreCategoriesContext.Provider>
  );
};

export default OperationStoreCategoriesContextProvider;